import { Button, SmartForm } from "@avenueops/web-components";
import { ArrowTopRightOnSquareIcon, CubeTransparentIcon, LockClosedIcon, LockOpenIcon } from "@heroicons/react/24/outline";
import Link from "next/link";
import { pagesPath } from "utils/$path";
import { trpc } from "utils/trpc";

export function SelectForm(): JSX.Element {
  const { data: forms, isLoading } = trpc.forms.listForms.useQuery();

  // TODO: deprecate legacySlackBlocks flag
  const filteredForms = forms?.filter((form) => !form.legacySlackBlocks && !form.public);
  const publicForms = forms?.filter((form) => !form.legacySlackBlocks && form.public);

  const formOptions = [
    ...(filteredForms ?? []).map((form) => {
      return {
        value: form.id,
        label: form.title ?? form.id,
        icon: <LockClosedIcon className="w-4 h-4 text-gray-950" />,
      };
    }),
    ...(publicForms && publicForms.length > 0
      ? [
          {
            label: "Public Forms",
            options: publicForms?.map((form) => {
              return {
                value: form.id,
                label: form.title ?? form.id,
                icon: <LockOpenIcon className="w-4 h-4 text-gray-950" />,
              };
            }),
          },
        ]
      : []),
  ];
  return (
    <div className="flex flex-wrap gap-5">
      {forms && forms.length > 0 && formOptions && formOptions.length > 0 ? (
        <SmartForm.DropdownSelect title="Form" name="formTemplateId" options={formOptions} defaultValue={forms[0].id} />
      ) : (
        <div className="w-full flex flex-col justify-center items-center">
          <CubeTransparentIcon className="w-12 h-12 text-gray-950" />
          <h2 className="my-5 text-gray-950">You have no forms yet!</h2>
          <Button>
            <Link href={pagesPath.forms.builder.$url()} target="__blank" className="flex items-center">
              Create form
              <ArrowTopRightOnSquareIcon className="w-4 h-4 ml-2 inline" />
            </Link>
          </Button>
        </div>
      )}
    </div>
  );
}
